export type ModelSection =
  | "eleven_music"
  | "image_video"
  | "sound_effects"
  | "speech_to_speech"
  | "speech_to_text"
  | "text_to_speech"
  | "voice_isolator";

export type ProductSection =
  | "audio_native"
  | "automatic_dubbing"
  | "conversational_ai"
  | "dubbing"
  | "dubbing_studio"
  | "productions"
  | "studio"
  | "voices";

export type Section = ModelSection | ProductSection;

export const DEFAULT_MODELS: ModelSection[] = [
  "text_to_speech",
  "speech_to_text",
  "speech_to_speech",
  "sound_effects",
  "voice_isolator",
  "eleven_music",
];

export const DEFAULT_PRODUCTS: ProductSection[] = ["conversational_ai", "dubbing", "voices", "studio", "productions"];

// Tabbed pricing configuration (used in both regular and API pricing pages)
export const PRICING_TABS_MODELS: ModelSection[] = ["text_to_speech", "speech_to_text"];

export const PRICING_TABS_PRODUCTS: Section[] = [
  "conversational_ai",
  "speech_to_speech",
  "sound_effects",
  "voice_isolator",
  "eleven_music",
  "image_video",
  ...DEFAULT_PRODUCTS.filter(p => p !== "conversational_ai"),
];
